/*
 * Copyright (c) 2021 by Leyton Group - All Rights Reserved.
 *  This source code, and resulting software, is the confidential and proprietary information
 *  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
 *  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
 *  and shall use it only in accordance with the terms and conditions of any and all license
 *  agreements you have entered into with The Company.
 */

import { simulationService } from "../views/Simulations/services";
import { workService } from "../views/Works/services";
import { userService } from "@/views/service/user.service";
import moment from "moment";
import Vue from "vue";
import _ from "lodash";
import { constants } from "@/shared/constants";
import { router } from "@/plugins/vue-router";

const state = {
  currentStep: 0,
  currentStepId: -1,
  simulationType: "COMPLEX",
  simulations: [],
  simulation: {},
  componentName: "",
  isEdit: null,
  selectedSimulationId: null,
  simulationCount: 0,
  simulationTypes: [
    {
      label: "simple_simulation",
      text:
        "J'ai un document décrivant mon projet et je souhaite avoir une estimation sur cette base.",
      value: constants.SIMULATION_TYPE.SIMPLE,
      icon: require("@/assets/images/simple-simulation.svg"),
      activeIcon: require("@/assets/images/simple-simulation-active.svg")
    },
    {
      label: "complex_simulation",
      text:
        "J'ai le détail de mon projet et je peux renseigner les informations nécessaires afin d'avoir une estimation.",
      value: constants.SIMULATION_TYPE.COMPLEX,
      icon: require("@/assets/images/complex-simulation-icon-svg.svg"),
      activeIcon: require("@/assets/images/complex-simulation-icon-active.svg")
    },
    {
      label: "import_in_mass_simulation",
      text:
        "J'ai un fichier CSV regroupant les informations de mes opérations et je souhaite les importer en masse.",
      value: constants.SIMULATION_TYPE.IMPORT_MASS,
      icon: require("@/assets/images/import-in-mass-simulation.svg"),
      activeIcon: require("@/assets/images/import-in-mass-simulation-active.svg")
    }
  ],
  goNextStepDisabled: false,
  steps: [
    {
      key: 0,
      name: "step_1_name",
      status: "Pending"
    },
    {
      key: 1,
      name: "Informations générales",
      status: "Pending"
    },
    {
      key: 2,
      name: "Planning",
      status: "Pending"
    },
    {
      key: 3,
      name: "Opérations",
      status: "Pending"
    },
    {
      key: 4,
      name: "Opérations En Masse",
      status: "Pending"
    },
    {
      key: 5,
      name: "Documents",
      status: "Pending"
    },
    {
      key: 6,
      name: "Terminer",
      status: "Pending"
    }
  ],
  users: [],
  operations: {},
  assignOperations: {},
  operation: {},
  applicationSector: {},
  applicationSectorType: {},
  messageries: [],
  simulationChanged: false
};
const getters = {
  getSimulations: state => state.simulations,
  getSimulation: state => state.simulation,
  getSelectedSimulationId: state => state.selectedSimulationId,
  getCurrentStep: state => state.currentStep,
  getSimulationTypes: state => state.simulationTypes,
  getSimulationType: state => state.simulationType,
  getSteps: state => state.steps,
  isCurrentStep: state => step => {
    return state.steps[step].status === "CURRENT";
  },
  getComponentName: state => state.componentName,
  isEdit: state => state.isEdit,
  getSimulationCount: state => state.simulationCount,
  getGoNextStepDisabled: state => state.goNextStepDisabled,
  getUsers: state => state.users,
  getOperations: state => state.operations,
  getAssignOperations: state => state.assignOperations,
  getOperation: state => state.operation,
  getApplicationSector: state => state.applicationSector,
  getApplicationSectorType: state => state.applicationSectorType,
  getMessageries: state => state.messageries,
  getSimulationChanged: state => state.simulationChanged
};
const actions = {
  selectedSimulationIdAction({ commit }, { simulationId }) {
    commit("setSelectedSimulationId", simulationId);
  },
  persistSimulationAction({ dispatch, commit, state }, { simulation }) {
    simulationService.persistSimulation(simulation).then(
      result => {
        const currentDate = moment().format("YYYY-MM-DD");
        const deliveryDate = new Date(result.deliveryDate).getTime();
        const desiredReturnDate = new Date(result.desiredReturnDate).getTime();
        const submissionTechnicalOfferDate = new Date(
          result.submissionTechnicalOfferDate
        ).getTime();
        const contractingProjectDate = new Date(
          result.contractingProjectDate
        ).getTime();
        const workStartDate = new Date(result.workStartDate).getTime();
        result.deliveryDate =
          deliveryDate > 0 || !state.isEdit ? result.deliveryDate : currentDate;
        result.desiredReturnDate =
          desiredReturnDate > 0 || !state.isEdit
            ? result.desiredReturnDate
            : currentDate;
        result.submissionTechnicalOfferDate =
          submissionTechnicalOfferDate > 0 || !state.isEdit
            ? result.submissionTechnicalOfferDate
            : currentDate;
        result.contractingProjectDate =
          contractingProjectDate > 0 || !state.isEdit
            ? result.contractingProjectDate
            : currentDate;
        result.workStartDate =
          workStartDate > 0 || !state.isEdit
            ? result.workStartDate
            : currentDate;
        commit("setSimulation", result);
        commit("setSimulationType", result.type);
      },
      error => {
        dispatch("loader/hideSaveSimulationLoader", true, { root: true });
        console.log(error);
      }
    );
  },
  persistEstimationsAction({ dispatch, commit, state }, { data }) {
    return simulationService.persistComplexSimulation(data).then(() => {});
  },
  resetSimulationAction({ commit }) {
    commit("setSimulation", { isDraft: true });
    commit("setSimulationType", "COMPLEX");
    commit("goToStep", 0);
  },
  validateOrLoseSimulationAction(
    { dispatch, commit },
    { id, lose, reason, message }
  ) {
    return simulationService.validateOrLose(id, lose, reason, message);
  },
  getSimulationsAction(
    { commit },
    { currentPage, perPage, sortBy, sortDir, customFilter, search, tab }
  ) {
    simulationService
      .fetchSimulations(
        currentPage,
        perPage,
        sortBy,
        sortDir,
        customFilter,
        search,
        tab
      )
      .then(
        result => {
          commit("setSimulations", result);
        },
        error => {
          console.log(error);
        }
      );
  },
  getSimulationsAdminAgence(
    { commit },
    {
      currentPage,
      perPage,
      sortBy,
      sortDir,
      customFilter,
      search,
      agenceId,
      tab
    }
  ) {
    simulationService
      .fetchSimulationsAdminAgence(
        currentPage,
        perPage,
        sortBy,
        sortDir,
        customFilter,
        search,
        agenceId,
        tab
      )
      .then(
        result => {
          commit("setSimulations", result);
        },
        error => {
          console.log(error);
        }
      );
  },
  getSimulationsChargeDeProjet(
    { commit },
    { currentPage, perPage, sortBy, sortDir, customFilter, search, tab }
  ) {
    simulationService
      .fetchSimulationsChargeDeProjet(
        currentPage,
        perPage,
        sortBy,
        sortDir,
        customFilter,
        search,
        tab
      )
      .then(
        result => {
          commit("setSimulations", result);
        },
        error => {
          console.log(error);
        }
      );
  },
  getSimulationsChargeDeProjetById(
    { commit },
    { currentPage, perPage, sortBy, sortDir, customFilter, search, userId, tab }
  ) {
    simulationService
      .fetchSimulationsChargeDeProjetById(
        currentPage,
        perPage,
        sortBy,
        sortDir,
        customFilter,
        search,
        userId,
        tab
      )
      .then(
        result => {
          commit("setSimulations", result);
        },
        error => {
          console.log(error);
        }
      );
  },
  getSimulationByIdAction({ commit }, { id }) {
    workService.fetchWorkById(id).then(
      result => {
        commit("setSimulation", result);
      },
      error => {
        console.log(error);
        // dispatch("alert/error", error, { root: true });
      }
    );
    workService.fetchWorkMessageries(id).then(
      result => {
        commit("setMessageries", result);
      },
      error => {
        Vue.$log.error(error);
      }
    );
  },
  getSimulationCountAction({ commit }) {
    simulationService.fetchSimulationCount().then(
      result => {
        commit("setSimulationCount", result);
      },
      error => {
        console.log(error);
      }
    );
  },
  getSimulationCountActionAdminAgence({ commit }, { agenceId }) {
    simulationService.fetchSimulationCountAdminAgence(agenceId).then(
      result => {
        commit("setSimulationCount", result);
      },
      error => {
        console.log(error);
      }
    );
  },
  getSimulationCountActionChargeDeProjet({ commit }) {
    simulationService.fetchSimulationCountChargeDeProjet().then(
      result => {
        commit("setSimulationCount", result);
      },
      error => {
        console.log(error);
      }
    );
  },
  async fetchUsersByAgency({ commit }, agency) {
    try {
      const id = agency === -1 ? agency : agency?.id;
      var result = await userService.agenceUsersList(id);
      commit("setUsersAgence", result);
      return result;
    } catch (error) {
      console.error(error);
    }
  },
  getSimulationOperationsAction(
    { commit },
    { id, currentPage, perPage, sortBy, sortDir, customFilter, search }
  ) {
    simulationService
      .getOperations(
        id,
        currentPage,
        perPage,
        sortBy,
        sortDir,
        customFilter,
        search
      )
      .then(
        result => {
          commit("setOperations", result);
        },
        error => {
          Vue.$log.error(error);
        }
      );
  },
  async getSimulationAssignOperations(
    { commit },
    { id, currentPage, perPage, sortBy, sortDir, customFilter, search }
  ) {
    simulationService
      .getAssignOperations(
        id,
        currentPage,
        perPage,
        sortBy,
        sortDir,
        customFilter,
        search
      )
      .then(
        result => {
          commit("setAssignOperations", result);
          return result;
        },
        error => {
          Vue.$log.error(error);
        }
      );
  },
  getOperationByIdAction({ commit }, { idWork, idOperation }) {
    simulationService.fetchSimulationOperation(idOperation).then(
      result => {
        if (result) {
          commit("setOperation", result);
          const appSector = constants.APPLICATION_SECTORS.find(
            el => el.value === state.operation.fiche.applicationSector
          );
          const type = appSector.types.find(
            el => el.value === state.operation.fiche.type
          );
          console.log(appSector.name);
          console.log(type.name);
          commit("setApplicationSector", appSector);
          commit("setApplicationSectorType", type);
        } else {
          Vue.prototype.$notification.error("Opération non trouvée");
          router.push({ name: "SimulationDetail", params: { id: idWork } });
        }
      },
      error => {
        Vue.$log.error(error);
      }
    );
  },
  getMessageriesAction({ commit }, { refClientId, loaded }) {
    workService.fetchWorkMessageries(refClientId, loaded).then(
      result => {
        commit("setMessageries", result);
      },
      error => {
        Vue.$log.error(error);
      }
    );
  },

  submitAnswerAction(
    { commit, dispatch },
    { questionId, MessagerieAnswerDto, workId }
  ) {
    workService.submitAnswer(questionId, MessagerieAnswerDto).then(
      answer => {
        dispatch("getMessageriesAction", { refClientId: workId, loaded: true });
      },
      error => {
        Vue.$log.error(error);
      }
    );
  },

  submitModifiedAnswerAction(
    { commit, dispatch },
    { questionId, MessagerieAnswerDto, workId }
  ) {
    workService.submitModifiedAnswer(questionId, MessagerieAnswerDto).then(
      nesAnswer => {
        dispatch("getMessageriesAction", { refClientId: workId, loaded: true });
        dispatch("getMessageriesAction");
      },
      error => {
        Vue.$log.error(error);
      }
    );
  },

  deleteAnswerAction({ commit, dispatch }, { questionId, historyId, workId }) {
    workService.deleteAnswer(questionId, historyId).then(
      result => {
        dispatch("getMessageriesAction", { refClientId: workId, loaded: true });
      },
      error => {
        Vue.$log.error(error);
      }
    );
  }
};
const mutations = {
  setSimulations(state, val) {
    state.simulations = val;
  },
  setSimulation(state, val) {
    state.simulation = val;
  },
  setGoNextStepDisabled(state, val) {
    console.log("setGoNextStepDisabled", val);
    state.goNextStepDisabled = val;
  },
  setSelectedSimulationId(state, val) {
    state.selectedSimulationId = val;
  },
  goToStep(state, step) {
    state.currentStep = step;
  },
  setSimulationType(state, type) {
    state.simulationType = type;
  },
  changeStepStatus(state, payload) {
    state.steps[payload.key].status = payload.status;
  },
  setComponentName(state, val) {
    state.componentName = val;
  },
  setIsEdit(state, val) {
    state.isEdit = val;
  },
  setSimulationCount(state, val) {
    state.simulationCount = val;
  },
  setUsersAgence(state, users) {
    state.users = users;
  },
  setOperations(state, val) {
    state.operations = val;
  },
  setAssignOperations(state, val) {
    state.assignOperations = val;
  },
  setOperation(state, val) {
    state.operation = val;
  },
  setApplicationSector(state, val) {
    state.applicationSector = val;
    console.log("changed to", state.applicationSector.name);
  },
  setApplicationSectorType(state, val) {
    state.applicationSectorType = val;
    console.log("changed to", state.applicationSectorType.name);
  },
  setMessageries(state, val) {
    let index = 0;
    state.messageries = _.map(val, function(element) {
      return _.extend({}, element, {
        shown: false,
        index: index++,
        shouldLoading: false
      });
    });
  },
  setSimulationChanged(state, val) {
    state.simulationChanged = val;
  }
};

export const simulation = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
